import CardCommon from '@op/components/CardCommon';
import Sentiment from '@op/components/Snippets/Sentiment';
import { NO_DATE } from '@op/constants';
import useLanguage from '@op/hooks/useLanguage';
import { useRealTimeStreamingKeyMessage } from '@op/pages/RealtimeStreaming/hooks/useRealTimeStreamingSummary';
import { SummaryTopicList } from '@op/pages/RealtimeStreaming/type';
import { getLiveTimeTitle } from '@op/pages/RealtimeStreaming/utils';
import { DBO_TM } from '@op/utils/format';
import { getSteamingSummaryText } from '@op/utils/languageValue';
import moment from 'moment';
import React from 'react';
import { Button, List, Modal, StatusTip, Tag } from 'tea-component';

const sentimentMap: {
  [key: string]: 1 | 5 | 3;
} = {
  positive: 5,
  negative: 1,
  neutral: 3,
};

export function SummaryItem({ data }: { data: SummaryTopicList }) {
  const sentimentValue = data?.sentiment
    ? data.sentiment.toLocaleLowerCase()
    : data?.sentiment;
  const { isEn } = useLanguage();

  return (
    <div className="dbo-summary-item-box">
      <div className="dbo-live-charts-analysis-title">
        {sentimentValue && (
          <Sentiment
            showValue={false}
            sentiment={sentimentMap[sentimentValue]}
          ></Sentiment>
        )}
        <span className="dbo-live-charts-analysis-subtitle">
          {getLiveTimeTitle({
            startTime: data.start_time,
            endTime: data.end_time,
          })}
        </span>
        <div className="dbo-tea-tag-list">
          {Object.entries(data?.topics || {}).map(([key, value]) => (
            <Tag key={key} className={`dbo-tea-tag dbo-tea-tag--${value}`}>
              {key}
            </Tag>
          ))}
        </div>
      </div>

      <div>{getSteamingSummaryText(data, isEn ? 'origin' : 'zh')}</div>
    </div>
  );
}

export default function KolQuotesModal({
  close,
  filter,
  liveTime
}: {
  close: () => void;
  filter: any;
  liveTime: string;
}) {
  const { formatMessage } = useLanguage();

  const { loading, data, isNoMore, nextPage, total } =
    useRealTimeStreamingKeyMessage({
      filter,
    });

  function getTimeInfo(data: any) {
    const { start_time, end_time } = data || {};
    const startTime = moment(start_time).format('YYYY-MM-DD HH:mm:ss');
    const endTime = moment(end_time).format('YYYY-MM-DD HH:mm:ss');

    const realTime = DBO_TM.floor(liveTime!);
    return {
      start_time: DBO_TM.subtract(startTime, realTime),
      end_time: DBO_TM.subtract(endTime, realTime),
    };
  }

  return (
    <Modal
      size={'xl'}
      visible={true}
      caption={formatMessage('KOL Quotes')}
      onClose={close}
    >
      <Modal.Body>
        <CardCommon contentCard>
          <List
            style={{ maxHeight: '500px', overflow: 'auto' }}
            onScrollBottom={() => {
              if (!loading && !isNoMore) nextPage();
            }}
          >
            {data.map((item, index) => {
              return (
                <List.Item key={item.start_time + item.end_time + index + item?.sentiment}>
                  <SummaryItem
                    data={item}
                  ></SummaryItem>
                </List.Item>
              );
            })}
            <List.Item
              key={'loading'}
              className={`dbo-loading-box ${total === 0 ? '' : '--nofirst'}`}
            >
              <StatusTip
                className={`dbo-loading`}
                status={loading ? 'loading' : 'empty'}
                emptyText={data.length > 0 ? '' : formatMessage(NO_DATE.TITLE)}
              />
            </List.Item>
          </List>
        </CardCommon>
      </Modal.Body>
      <Modal.Footer>
        <Button type="primary" onClick={close}>
          {formatMessage('Close')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
